import {composeReducers, createReducerFunction} from 'immer-reducer'
import defaultState from 'redux/jobRequests/state'
import JobRequest from './jobRequests.duck'

export default composeReducers(
  createReducerFunction(JobRequest, defaultState)
)
